import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const bingDesktopTextRaw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  key: 'bing_text',
  type: 'BingText',
  associationType: 'BingText',
  minimumRequirements: 0,
  localizedText: {
    previewTypeStringKey: _TL_('Bing search ad'),
    stringKey: _TL_(''),
  },
  previewSettings: {
    showLongHeadline: true,
    showDescription: true,
    showUrl: true,
    showMultipleLineLongHeadline: true,
    showUrlMultiline: true,
    showMultipleDescription: true,
    showAdsLabelInlineWithDescription: true,
    showPreviewTypeString: false,
  },
  styleOverrides: {
    previewContent: {
      border: 'none',
      boxShadow: 'none',
      width: 308,
      maxHeight: 260,
      padding: '8px 16px',
      overflow: 'hidden',
    },
    adsLabel: {
      border: '1px solid #ddd',
      padding: '0 2px',
      fontSize: 11,
      fontWeight: 600,
      lineHeight: 1,
      borderRadius: 6,
      margin: '0 4px 0 0',
      display: 'inline',
      color: '#767676',
      opacity: '100%',
      position: 'static',
      maxHeight: 16,
    },
    textContainer: {
      margin: '4px 8px 0px 8px',
    },
    longHeadline: {
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '24px',
      height: '28px',
      overflow: 'hidden',
    },
    finalUrl: {
      overflow: 'hidden',
      color: '#0b6a0b',
      fontSize: '12px',
      height: '20px',
      marginBottom: '5px',
    },
    description: {
      color: '#333',
      display: 'inline-block',
      fontSize: '12px',
      flexGrow: 1,
      marginBottom: '10px',
    },
    descriptionParent: {
      display: 'flex',
    },
  },
};

export default bingDesktopTextRaw;
